<script setup>
import FicheDePresence from '@/components/conges/fiche-de-presence/fiche-de-presence.vue'
import CongesApercu from '@/components/conges/apercu/conges-apercu.vue'
import SPage from '@/components/global/s-page.vue'
</script>

<template>
  <s-page v-if="loaded">
    <template v-slot:main-panel>
      <v-container class="pb-0" fluid>
        <v-row>
          <v-col class="wh-100">
            <conges-apercu :etablissementId="selectedEtablissement.etablissementId" />
          </v-col>
          <v-col cols="4" class="wh-100 d-none d-xl-inline">
            <fiche-de-presence :etablissement-id="selectedEtablissement.etablissementId" />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </s-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { initialDataLoaded } from '@/store/modules/helpers'

export default {
  name: 'etablissement-tableau-conges',
  data() {
    return {}
  },
  computed: {
    ...initialDataLoaded,
    ...mapGetters({
      selectedEtablissement: 'application/getSelectedEtablissement',
      isInRole: 'security/isInRole',
    }),
    loaded() {
      return initialDataLoaded && this.selectedEtablissement
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wh-100 {
  max-height: 90vh;
}
</style>
